// extracted by mini-css-extract-plugin
export default {"root":"ExtraIcons_root__JM9jj"};